(() => {
    window.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll('.footer .nav > li').forEach(((node) => {
            node.addEventListener('click', () => {
                node.classList.toggle('open')
            })
        }))
    })
}) ()

